import { render, staticRenderFns } from "./CounterpartTypePill.vue?vue&type=template&id=19bbc793&scoped=true"
import script from "./CounterpartTypePill.vue?vue&type=script&lang=js"
export * from "./CounterpartTypePill.vue?vue&type=script&lang=js"
import style0 from "./CounterpartTypePill.vue?vue&type=style&index=0&id=19bbc793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bbc793",
  null
  
)

export default component.exports